import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, HelpCircle, Wallet, Flame, Clock, Sparkles, ChefHat, Download, ShieldCheck } from 'lucide-react';
interface FaqItem {
  icon: React.ReactNode;
  q: string;
  a: string;
}
const faqs: FaqItem[] = [{
  icon: <Wallet className="w-5 h-5" strokeWidth={1.75} data-id="element-96" />,
  q: '¿El plan es caro?',
  a: 'No, está basado en ingredientes de feria y supermercado local.'
}, {
  icon: <Flame className="w-5 h-5" strokeWidth={1.75} data-id="element-97" />,
  q: '¿Tengo que dejar de comer asados?',
  a: 'No, te enseñamos a elegir para que disfrutes sin inflamarte.'
}, {
  icon: <Clock className="w-5 h-5" strokeWidth={1.75} data-id="element-98" />,
  q: '¿Cuánto tiempo me tomará ver resultados?',
  a: 'La mayoría de las mujeres reportan menos hinchazón en las primeras 48 a 72 horas.'
}, {
  icon: <Sparkles className="w-5 h-5" strokeWidth={1.75} data-id="element-99" />,
  q: '¿Sirve para la menopausia?',
  a: 'Absolutamente, está diseñado para el cambio hormonal de esta etapa.'
}, {
  icon: <ChefHat className="w-5 h-5" strokeWidth={1.75} data-id="element-100" />,
  q: '¿Necesito saber cocinar?',
  a: 'No. Todas las recetas son para personas sin experiencia culinaria. Si puedes hervir agua y usar un sartén, puedes seguir este plan.'
}, {
  icon: <Download className="w-5 h-5" strokeWidth={1.75} data-id="element-101" />,
  q: '¿Cómo recibo el plan después de comprar?',
  a: 'Inmediatamente después de tu pago recibes un enlace de descarga directa. Es un archivo PDF que puedes leer en tu teléfono, tablet o computador — sin apps ni suscripciones.'
}, {
  icon: <ShieldCheck className="w-5 h-5" strokeWidth={1.75} data-id="element-102" />,
  q: '¿Y si no me funciona?',
  a: 'Tienes 7 días de garantía total. Si no notas ninguna diferencia, te devolvemos tu dinero sin preguntas ni formularios complicados.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-14 md:py-16 bg-white" data-id="element-103">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl" data-id="element-104">
        <div className="text-center mb-12" data-id="element-105">
          <div className="inline-flex items-center gap-2 bg-brand-gold/10 text-brand-gold px-4 py-1.5 rounded-full font-bold text-xs uppercase tracking-wider mb-4" data-id="element-106">
            <HelpCircle className="w-4 h-4" data-id="element-107" />
            Preguntas frecuentes
          </div>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-navy" data-id="element-108">
            Todo lo que necesitas saber
          </h2>
          <div className="w-20 h-1 bg-brand-gold mx-auto mt-5 rounded-full" data-id="element-109" />
        </div>

        <div className="space-y-3" data-id="element-110">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className={`border rounded-2xl overflow-hidden transition-colors ${isOpen ? 'border-brand-gold/40 bg-brand-cream/40' : 'border-gray-200 bg-brand-cream/20 hover:bg-brand-cream/30'}`} data-id="element-111">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-5 sm:px-6 py-5 flex items-center gap-4 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold focus-visible:ring-offset-2 rounded-2xl" aria-expanded={isOpen} data-id="element-112">
                  <div className={`shrink-0 w-10 h-10 rounded-xl flex items-center justify-center transition-colors ${isOpen ? 'bg-brand-gold text-white' : 'bg-brand-navy/5 text-brand-navy'}`} data-id="element-113">
                    {faq.icon}
                  </div>
                  <span className="flex-1 font-semibold text-brand-navy text-base sm:text-lg leading-snug" data-id="element-114">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 text-brand-gold transition-transform duration-300 shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-115" />
                </button>

                <AnimatePresence initial={false} data-id="element-116">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-117">
                      <div className="px-5 sm:px-6 pb-5 pt-1 pl-[4.5rem] sm:pl-[4.75rem] text-gray-700 leading-relaxed text-sm sm:text-base" data-id="element-118">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}